/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    NftPurchaseCartItem,
    NftPurchaseCartItemFromJSON,
    NftPurchaseCartItemFromJSONTyped,
    NftPurchaseCartItemToJSON,
    NftPurchaseLog,
    NftPurchaseLogFromJSON,
    NftPurchaseLogFromJSONTyped,
    NftPurchaseLogToJSON,
    NftPurchaseStatus,
    NftPurchaseStatusFromJSON,
    NftPurchaseStatusFromJSONTyped,
    NftPurchaseStatusToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Used to save an Industry collection purchase attempt.
 * @export
 * @interface NftPurchase
 */
export interface NftPurchase {
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftPurchase
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftPurchase
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    user: string;
    /**
     * 
     * @type {NftPurchaseStatus}
     * @memberof NftPurchase
     */
    status: NftPurchaseStatus;
    /**
     * 
     * @type {Array<NftPurchaseLog>}
     * @memberof NftPurchase
     */
    log: Array<NftPurchaseLog>;
    /**
     * 
     * @type {number}
     * @memberof NftPurchase
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof NftPurchase
     */
    stripeTotal: number;
    /**
     * 
     * @type {number}
     * @memberof NftPurchase
     */
    dpay: number;
    /**
     * 
     * @type {number}
     * @memberof NftPurchase
     */
    fiatInDpay: number;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    dpayTransaction?: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    dpayTransactionRefund?: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    paymentIntentId?: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    paymentIntentRefundId?: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    walletAddress: string;
    /**
     * 
     * @type {string}
     * @memberof NftPurchase
     */
    coinbaseChargeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftPurchase
     */
    isCoinbase?: boolean;
    /**
     * 
     * @type {Array<NftPurchaseCartItem>}
     * @memberof NftPurchase
     */
    cartItems: Array<NftPurchaseCartItem>;
}

export function NftPurchaseFromJSON(json: any): NftPurchase {
    return NftPurchaseFromJSONTyped(json, false);
}

export function NftPurchaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftPurchase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'user': json['user'],
        'status': NftPurchaseStatusFromJSON(json['status']),
        'log': ((json['log'] as Array<any>).map(NftPurchaseLogFromJSON)),
        'total': json['total'],
        'stripeTotal': json['stripeTotal'],
        'dpay': json['dpay'],
        'fiatInDpay': json['fiatInDpay'],
        'dpayTransaction': !exists(json, 'dpayTransaction') ? undefined : json['dpayTransaction'],
        'dpayTransactionRefund': !exists(json, 'dpayTransactionRefund') ? undefined : json['dpayTransactionRefund'],
        'paymentMethodId': !exists(json, 'paymentMethodId') ? undefined : json['paymentMethodId'],
        'paymentIntentId': !exists(json, 'paymentIntentId') ? undefined : json['paymentIntentId'],
        'paymentIntentRefundId': !exists(json, 'paymentIntentRefundId') ? undefined : json['paymentIntentRefundId'],
        'walletAddress': json['walletAddress'],
        'coinbaseChargeId': !exists(json, 'coinbaseChargeId') ? undefined : json['coinbaseChargeId'],
        'isCoinbase': !exists(json, 'isCoinbase') ? undefined : json['isCoinbase'],
        'cartItems': ((json['cartItems'] as Array<any>).map(NftPurchaseCartItemFromJSON)),
    };
}

export function NftPurchaseToJSON(value?: NftPurchase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'user': value.user,
        'status': NftPurchaseStatusToJSON(value.status),
        'log': ((value.log as Array<any>).map(NftPurchaseLogToJSON)),
        'total': value.total,
        'stripeTotal': value.stripeTotal,
        'dpay': value.dpay,
        'fiatInDpay': value.fiatInDpay,
        'dpayTransaction': value.dpayTransaction,
        'dpayTransactionRefund': value.dpayTransactionRefund,
        'paymentMethodId': value.paymentMethodId,
        'paymentIntentId': value.paymentIntentId,
        'paymentIntentRefundId': value.paymentIntentRefundId,
        'walletAddress': value.walletAddress,
        'coinbaseChargeId': value.coinbaseChargeId,
        'isCoinbase': value.isCoinbase,
        'cartItems': ((value.cartItems as Array<any>).map(NftPurchaseCartItemToJSON)),
    };
}


